export const MetropolisCities = [
    { name: 'Albigny-sur-Saône', postcode: '69250' },
    { name: 'Bron', postcode: '69500' },
    { name: 'Cailloux-sur-Fontaines', postcode: '69270' },
    { name: 'Caluire-et-Cuire', postcode: '69300' },
    { name: "Champagne-au-Mont-d'Or", postcode: '69410' },
    { name: 'Charbonnières-les-Bains', postcode: '69260' },
    { name: 'Charly', postcode: '69390' },
    { name: 'Chassieu', postcode: '69680' },
    { name: "Collonges-au-Mont-d'Or", postcode: '69660' },
    { name: 'Corbas', postcode: '69680' },
    { name: "Couzon-au-Mont-d'Or", postcode: '69270' },
    { name: 'Craponne', postcode: '69290' },
    { name: "Curis-au-Mont-d'Or", postcode: '69250' },
    { name: 'Dardilly', postcode: '69570' },
    { name: 'Décines-Charpieu', postcode: '69150' },
    { name: 'Écully', postcode: '69130' },
    { name: 'Feyzin', postcode: '69320' },
    { name: "Fleurieu-sur-Saône", postcode: '69250' },
    { name: "Fontaines-Saint-Martin", postcode: '69270' },
    { name: "Fontaines-sur-Saône", postcode: '69270' },
    { name: 'Francheville', postcode: '69130' },
    { name: 'Genay', postcode: '69730' },
    { name: 'Givors', postcode: '69700' },
    { name: 'Grigny', postcode: '69520' },
    { name: 'Irigny', postcode: '69540' },
    { name: 'Jonage', postcode: '69330' },
    { name: 'Limonest', postcode: '69760' },
    { name: 'Lissieu', postcode: '69380' },
    { name: 'Lyon', postcode: '69000' },
    { name: "Marcy-l'Étoile", postcode: '69280' },
    { name: 'Meyzieu', postcode: '69330' },
    { name: 'Mions', postcode: '69780' },
    { name: 'Montanay', postcode: '69250' },
    { name: 'Mulatière', postcode: '69350' },
    { name: 'Neuville-sur-Saône', postcode: '69250' },
    { name: 'Oullins', postcode: '69000' },
    { name: 'Pierre-Bénite', postcode: '69310' },
    { name: "Poleymieux-au-Mont-d'Or", postcode: '69250' },
    { name: 'Quincieux', postcode: '69650' },
    { name: 'Rillieux-la-Pape', postcode: '69140' },
    { name: 'Rochetaillée-sur-Saône', postcode: '69270' },
    { name: "Saint-Cyr-au-Mont-d'Or", postcode: '69450' },
    { name: "Saint-Didier-au-Mont-d'Or", postcode: '69370' },
    { name: 'Saint-Fons', postcode: '69190' },
    { name: 'Saint-Genis-Laval', postcode: '69230' },
    { name: 'Saint-Genis-les-Ollières', postcode: '69290' },
    { name: "Saint-Germain-au-Mont-d'Or", postcode: '69650' },
    { name: 'Saint-Priest', postcode: '69800' },
    { name: "Saint-Romain-au-Mont-d'Or", postcode: '69270' },
    { name: 'Sainte-Foy-lès-Lyon', postcode: '69110' },
    { name: 'Sathonay-Camp', postcode: '69580' },
    { name: 'Sathonay-Village', postcode: '69580' },
    { name: 'Solaize', postcode: '69360' },
    { name: 'Tassin-la-Demi-Lune', postcode: '69160' },
    { name: 'Tour-de-Salvagny', postcode: '69890' },
    { name: 'Vaulx-en-Velin', postcode: '69120' },
    { name: 'Vénissieux', postcode: '69200' },
    { name: 'Vernaison', postcode: '69390' },
    { name: 'Villeurbanne', postcode: '69100' },
];
